import { Attr, Model } from 'spraypaint'
import ApplicationRecord from './applicationRecord'

@Model()
class Manufacturer extends ApplicationRecord {
  static jsonapiType = 'manufacturers'
  @Attr() name: string
  @Attr() email: string
  @Attr() address: string
  @Attr() phone: string

  @Attr() status: string
  @Attr() county: string
  @Attr() state: string
  @Attr() city: string
  @Attr() country: string
}

export default Manufacturer
